import React, { useState } from "react";
import styles from "./GroupedEventItem.module.css"; // or smaller css if you prefer
import { PlaydateInvite } from "../../gql/types";
import PlaydateInvitationCard from "../playdate/PlaydateInvitationCard";
import UnderlineButton from "../button/UnderlineButton";
import PlaydateInviteRecipientReviewWorkflow from "../playdate/workflow/recipient/review/PlaydateInviteRecipientReviewWorkflow";
import PlaydateInviteOrganizerReviewWorkflow from "../playdate/workflow/PlaydateInviteOrganizerReviewWorkflow";
import { useToastContext } from "contexts/ToastContext";

type PlaydateInviteSimpleWorkflowCardProps = {
    invite: PlaydateInvite;
};

const PlaydateInviteSimpleWorkflowCard: React.FC<PlaydateInviteSimpleWorkflowCardProps> = ({
    invite,
}) => {
    const [showWorkflow, setShowWorkflow] = useState(false);
    const { triggerToastEvent } = useToastContext();

    const isRecipient = !!invite.guestUpdate;

    if (!invite.guestUpdate && !invite.organizerUpdate) {
        return null;
    }

    const headerButtonText = "View Invite Details";

    return (
        <>
            <div className={styles.digestItem}>
                <PlaydateInvitationCard
                    invite={invite}
                    onBack={() => { }} // you can wire this later if needed
                    disableBottomDetails
                    headerElement={
                        <UnderlineButton
                            textSize="small"
                            onClick={() => setShowWorkflow(true)}
                        >
                            {headerButtonText}
                        </UnderlineButton>
                    }
                />
            </div>

            {showWorkflow && isRecipient && (
                <PlaydateInviteRecipientReviewWorkflow
                    invite={invite}
                    onBack={() => setShowWorkflow(false)}
                    onDataChange={(success) => {
                        if (success) {
                            triggerToastEvent();
                        }
                        setShowWorkflow(false);
                    }}
                />
            )}

            {showWorkflow && !isRecipient && (
                <PlaydateInviteOrganizerReviewWorkflow
                    invite={invite}
                    onBack={() => setShowWorkflow(false)}
                    onDataChange={(success) => {
                        if (success) {
                            triggerToastEvent();
                        }
                        setShowWorkflow(false);
                    }}
                />
            )}
        </>
    );
};

export default PlaydateInviteSimpleWorkflowCard;
